import { useCallback } from 'react';
import type { CommonBaseReferAFriendContext } from '@kiwicom/event-schemas';

export type ProgramVersion = CommonBaseReferAFriendContext['program_version'];

export const useBaseReferAFriendContext = () => {
  return useCallback(
    (program_version: ProgramVersion = 'v2') => ({
      program_version,
    }),
    [],
  );
};

export type { CommonBaseReferAFriendContext as BaseReferAFriendContext };
